import { useState } from 'react';
import { Lock } from 'lucide-react';

const CORRECT = process.env.REACT_APP_OUTREACH_PASSWORD || 'blackmagic2026';

export default function PasswordGate({ children }) {
  const [authed, setAuthed] = useState(
    () => sessionStorage.getItem('bmf_outreach_auth') === 'true'
  );
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    if (input === CORRECT) {
      sessionStorage.setItem('bmf_outreach_auth', 'true');
      setAuthed(true);
    } else {
      setError(true);
      setInput('');
      setTimeout(() => setError(false), 2500);
    }
  }

  if (authed) return children;

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-neutral-900 border border-neutral-800 mb-4">
            <Lock size={22} className="text-amber-400" />
          </div>
          <p className="text-xs tracking-[0.3em] uppercase text-amber-400 font-medium mb-1">
            Black Magic Films
          </p>
          <h1 className="text-2xl font-black">Outreach Dashboard</h1>
          <p className="text-neutral-500 text-sm mt-2">Internal access only</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="password"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Enter password"
            autoFocus
            className={`w-full bg-neutral-900 border rounded-xl px-4 py-3 text-white text-center placeholder-neutral-600 focus:outline-none transition-colors ${
              error
                ? 'border-red-500 focus:border-red-500'
                : 'border-neutral-700 focus:border-amber-400'
            }`}
          />
          {error && (
            <p className="text-red-400 text-sm text-center">Incorrect password</p>
          )}
          <button
            type="submit"
            className="w-full bg-amber-400 text-black font-bold py-3 rounded-full hover:bg-amber-300 transition-colors"
          >
            Unlock
          </button>
        </form>
      </div>
    </div>
  );
}
